"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var store_1 = require("@ngrx/store");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var skynet_store_authentication_api_1 = require("@synisys/skynet-store-authentication-api");
var skynet_store_languages_api_1 = require("@synisys/skynet-store-languages-api");
var lodash_decorators_1 = require("lodash-decorators");
var operators_1 = require("rxjs/operators");
var Subject_1 = require("rxjs/Subject");
var identity_1 = require("rxjs/util/identity");
var noop_1 = require("rxjs/util/noop");
var adapter_utillities_1 = require("./adapter.utillities");
var logger = adapter_utillities_1.createLogger('skynet-store-adapter-service');
var SkynetStoreAdapterService = /** @class */ (function () {
    function SkynetStoreAdapterService(store, authentication, cookie, currentLanguageProvider) {
        this.store = store;
        this.authentication = authentication;
        this.cookie = cookie;
        this.currentLanguageProvider = currentLanguageProvider;
        this.destructionSubject = new Subject_1.Subject();
        if (SkynetStoreAdapterService_1._initialized) {
            // throw Error('SkynetStoreAdapterService already initialized');
            logger.warn('SkynetStoreAdapterService already initialized');
        }
        SkynetStoreAdapterService_1._initialized = true;
        this.init();
    }
    SkynetStoreAdapterService_1 = SkynetStoreAdapterService;
    SkynetStoreAdapterService.prototype.ngOnDestroy = function () {
        this.destructionSubject.next();
        this.destructionSubject.complete();
    };
    SkynetStoreAdapterService.prototype.init = function () {
        var _this = this;
        this.currentLanguageProvider
            .getCurrentLanguage()
            .pipe(operators_1.tap(function (currentLanguage) {
            return _this.store.dispatch(new skynet_store_languages_api_1.SelectLanguageAction(currentLanguage.getId()));
        }), operators_1.takeUntil(this.destructionSubject))
            .subscribe(noop_1.noop, function (err) { return logger.error('%O', err); });
        this.dispatchToken();
        this.authentication
            .isLoggedOn()
            .pipe(operators_1.filter(identity_1.identity), operators_1.delay(100), operators_1.tap(function () { return _this.dispatchToken(); }), operators_1.takeUntil(this.destructionSubject))
            .subscribe(noop_1.noop, function (err) { return logger.error('%O', err); });
    };
    SkynetStoreAdapterService.prototype.dispatchToken = function () {
        var token = this.cookie.get(idm_authentication_client_js_1.AuthSettings.TOKEN_KEY_NAME);
        if (token) {
            this.store.dispatch(new skynet_store_authentication_api_1.AuthenticationSuccess(token));
        }
    };
    SkynetStoreAdapterService._initialized = false;
    __decorate([
        lodash_decorators_1.Memoize(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], SkynetStoreAdapterService.prototype, "init", null);
    SkynetStoreAdapterService = SkynetStoreAdapterService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [store_1.Store,
            idm_authentication_client_js_1.AuthenticationService,
            idm_authentication_client_js_1.CookieService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider])
    ], SkynetStoreAdapterService);
    return SkynetStoreAdapterService;
    var SkynetStoreAdapterService_1;
}());
exports.SkynetStoreAdapterService = SkynetStoreAdapterService;
//# sourceMappingURL=skynet-store-adapter.service.js.map